<template>
  <div class="row blog__content photos">
    <div
      class="col-sm-6 col-12 blog__content--news"
      v-for="(gallery, index) in galleries"
      :key="index"
      @click="showGallery(gallery)"
    >
      <div class="blog__content--news-image">
        <img :src="gallery.image" alt="Imagem da notícia" loading = “lazy”/>
      </div>
      <div class="blog__content--news-title">
        <div class="blog__content--news-title--date">
          {{ gallery.date }}
        </div>
        <div class="blog__content--news-title--text">
          {{ gallery.title }}
        </div>
      </div>
      <div class="blog__content--news-lead" v-html="gallery.description"></div>
      <viewer :images="gallery.gallery">
        <img v-for="src in images" :key="src" :src="src" loading = “lazy”/>
      </viewer>
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
Vue.use(VueViewer);

export default {
  props: ["galleries_obj"],
  data() {
    return {
      images: []
    }
  },
  created() {
    this.galleries = JSON.parse(this.galleries_obj);
  },
  methods: {
    showGallery(obj) {
      const image_list = [];
      for (let image of obj.gallery) {
        image_list.push(image.image);
      }
      this.$viewerApi({
        images: image_list
      });
    }
  }
}
</script>


<style lang="scss" scoped>
.photos {
  justify-content: unset;
  margin-bottom: 20px;
  & > div {
    margin-bottom: 15px;
    opacity: 1;
    transition: opacity 0.3s;
    :hover {
      cursor: pointer;
      opacity: 0.9;
      transition: opacity 0.3s;
    }
  }
}
</style>